import apiRoutes from './api.routes';
import ModelService from './model.service';

const PageService = new ModelService(apiRoutes.pages, '/pages', 'pages');

PageService.getImage = (filename, w = false, h = false, c = false) => PageService.getFilePathByDir('/uploads/pages', filename, w, h, c);

export default PageService;



// WEBPACK FOOTER //
// ./src/services/page.service.js